import api from './client';

export const getEmgStopGroups = (projectId) => api.get('/emg-stop-groups', { params: { project: projectId } });
export const createEmgStopGroup = (data) => api.post('/emg-stop-groups', data);
export const updateEmgStopGroup = (id, data) => api.put(`/emg-stop-groups/${id}`, data);
export const deleteEmgStopGroup = (id) => api.delete(`/emg-stop-groups/${id}`);
